// 项目类型枚举
export enum ProjectType {
  AI_EXPAND = 'expansion',
  AI_REMOVAL = 'watermark_removal',
  BACKGROUND_REMOVAL = 'background_removal',
  RESTORATION = 'restoration',
}

// 项目配置接口
export interface ProjectConfig {
  type: ProjectType;
  createNewRoute: string;
  createNewDescription: string;
  fileNamePrefix: string;
  displayName: string;
}

// 预定义的项目配置
export const PROJECT_CONFIGS: Record<string, ProjectConfig> = {
  [ProjectType.AI_EXPAND]: {
    type: ProjectType.AI_EXPAND,
    createNewRoute: '/ai-expand',
    createNewDescription:
      'Go beyond the crop. Instantly extend your image with flawless AI fill.',
    fileNamePrefix: 'ai-expand',
    displayName: 'AI Expanded Image',
  },
  [ProjectType.AI_REMOVAL]: {
    type: ProjectType.AI_REMOVAL,
    createNewRoute: '/watermark-removal',
    createNewDescription:
      'Create a new removal project to enhance your images.',
    fileNamePrefix: 'removal',
    displayName: 'AI Removal',
  },
  [ProjectType.BACKGROUND_REMOVAL]: {
    type: ProjectType.BACKGROUND_REMOVAL,
    createNewRoute: '/background-remove',
    createNewDescription:
      'Remove background from your images with AI technology.',
    fileNamePrefix: 'bg-removed',
    displayName: 'Background Removed Image',
  },
  [ProjectType.RESTORATION]: {
    type: ProjectType.RESTORATION,
    createNewRoute: '/photo-restoration',
    createNewDescription:
      'Restore and enhance your old or damaged photos with AI technology.',
    fileNamePrefix: 'restored',
    displayName: 'Restored Image',
  },
};

// AI Removal 子模块配置
export const AI_REMOVAL_SUB_MODULES = {
  all_types: { label: 'All Types', route: '/watermark-removal' },
  watermark_removal: {
    label: 'Watermark Removal',
    route: '/watermark-removal',
  },
  text_removal: { label: 'Text Removal', route: '/remove-text-from-image' },
  logo_removal: { label: 'Logo Removal', route: '/logo-remover' },
  signature_removal: { label: 'Signature Removal', route: '/remove-signature' },
  stamp_removal: { label: 'Stamp Removal', route: '/photo-stamp-remover' },
  sticker_removal: { label: 'Sticker Removal', route: '/sticker-remover' },
};
